<template>
    <div class="hotspot">
        <div class="inner">
            <div class="hotspot-title">{{ spot.title }}</div>
            <div class="hotspot-meta">
                {{ spot.address }}<br/>
                {{ spot.address2 }}<br/>
                {{ spot.metadata }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Hotspot",
        props: {
            spot: Object,
            imageWidth: Number,
            imageHeight: Number,
            index: Number,
            coords: Array,
            current: Number,
        },

        data: function () {
            return {
                isVisible: true,
                $labelInner: null,
            }
        },

        mounted() {
            this.$labelInner = $(this.$el).find('.inner');

            this.checkState();

            this.$watch('current', function () {
                this.checkState();
            });

            this.$nextTick(function () {
                this.position();
            });
        },

        methods: {
            position: function() {
                let width = $(this.$parent.$el).innerWidth();
                let height = $(this.$parent.$el).innerHeight();
                let labelWidth = this.$labelInner.innerWidth();
                let labelHeight = this.$labelInner.innerHeight();
                let viewRatio = width / height;
                let imageRatio = this.imageWidth / this.imageHeight;
                let scale, offset, x, y;

                if (imageRatio < viewRatio) {
                    scale = width / this.imageWidth;
                    offset = ((this.imageHeight * scale ) - height) / 2;
                    x = this.coords[0] * scale;
                    y = (this.coords[1] * scale) - offset;
                } else {
                    scale = height/this.imageHeight;
                    offset = ( (this.imageWidth * scale) - width ) / 2;
                    x = ( this.coords[0] * scale ) - offset;
                    y = this.coords[1] * scale;
                }

                // Adjust for Label Height and arrow height.
                y = y - labelHeight - 8;

                if(
                    y < 0 ||
                    y > height - labelHeight ||
                    x < (labelWidth / 2) ||
                    x > width - ( labelWidth / 2 )

                ) {
                    this.isVisible = false;
                }

                $(this.$el).css({
                    'left': x + 'px',
                    'top': y + 'px',
                });
            },

            checkState: function() {
                if (this.current === this.index && !this.isActive) {
                    this.show();
                } else if (this.current !== this.index && this.isActive) {
                    this.hide();
                }
            },

            show: function () {
                $(this.$el).attr("state-active", true);
                this.isActive = true;
            },

            hide: function () {
                $(this.$el).attr("state-active", false);
                this.isActive = false;
            }
        }

    }
</script>